export default __webpack_public_path__ + "static/media/HUMNL.3b13b5d0.png";